.imageCarouselWrapper {
  display: flex;
  flex-direction: column;
  width: var(--haus-imageCarousel__wrapper__width, 100%);
  border-radius: var(--haus-imageCarousel__wrapper__border-radius, 8px);
}

.productCarousel {
  display: flex;
  flex-direction: column;
  width: var(--haus-imageCarousel__productCarousel__width, 100%);
  gap: var(--haus-imageCarousel__productCarousel__gap, 0);
}

.productCarouselInner {
  width: var(--haus-imageCarousel__productCarouselInner__width, 100%);
  aspect-ratio: var(--haus-imageCarousel__img__aspect-ratio, 1 / 1);
  border-radius: var(--haus-imageCarousel__productCarouselInner__border-radius, 8px);

  .productCarouselImageArea {
    width: var(--haus-imageCarousel__productCarouselImageArea__width, 100%);
    height: var(--haus-imageCarousel__productCarouselImageArea__height, 100%);
    aspect-ratio: var(--haus-imageCarousel__img__aspect-ratio, 1 / 1);
  }

  .carouselPlaceholder {
    width: var(--haus-imageCarousel__carouselPlaceholder__width, 100%);
    height: var(--haus-imageCarousel__carouselPlaceholder__height, 100%);
  }
}

.imageOverlayTrigger {
  appearance: none;
  background: var(--haus-imageCarousel__imageOverlayTrigger__background, transparent);
  border: var(--haus-imageCarousel__imageOverlayTrigger__border, none);
  border-radius: var(--haus-imageCarousel__imageOverlayTrigger__border-radius, 8px);
  cursor: var(--haus-imageCarousel__imageOverlayTrigger__cursor, pointer);
  display: block;
  width: var(--haus-imageCarousel__imageOverlayTrigger__width, 100%);
  height: var(--haus-imageCarousel__imageOverlayTrigger__height, 100%);
  margin: var(--haus-imageCarousel__imageOverlayTrigger__margin, 0);
  padding: var(--haus-imageCarousel__imageOverlayTrigger__padding, 0);

  &:focus-visible {
    box-shadow: var(
      --haus-imageCarousel__imageOverlayTrigger__focus__box-shadow,
      0 0 0 2px var(--haus-color-primary, #667eea)
    );
    outline: var(
      --haus-imageCarousel__imageOverlayTrigger__focus__outline,
      2px solid var(--haus-color-primary, #667eea)
    );
    outline-offset: var(--haus-imageCarousel__imageOverlayTrigger__focus__outline-offset, 2px);
  }

  .productCarouselMainImageWrapper {
    --haus-badges__badge__height: var(--haus-imageCarousel__badge__height, calc(50% - 4px));

    width: var(--haus-imageCarousel__productCarouselMainImageWrapper__width, 100%);
    height: var(--haus-imageCarousel__productCarouselMainImageWrapper__height, 100%);
    display: var(--haus-imageCarousel__productCarouselMainImageWrapper__display, flex);
    position: var(--haus-imageCarousel__productCarouselMainImageWrapper__position, relative);
    align-items: var(--haus-imageCarousel__productCarouselMainImageWrapper__align-items, center);
    justify-content: var(
      --haus-imageCarousel__productCarouselMainImageWrapper__justify-content,
      center
    );
    overflow: var(--haus-imageCarousel__productCarouselMainImageWrapper__overflow, hidden);
    border-radius: var(--haus-imageCarousel__productCarouselMainImageWrapper__border-radius, 8px);
  }
}

.productCarouselImageAreaContainer {
  display: var(--haus-imageCarousel__imageAreaContainer__display, flex);
  align-items: var(--haus-imageCarousel__imageAreaContainer__align-items, center);
  justify-content: var(--haus-imageCarousel__imageAreaContainer__justify-content, center);
  gap: var(--haus-imageCarousel__imageAreaContainer__gap, 1.25rem);
  width: var(--haus-imageCarousel__imageAreaContainer__width, 100%);
}

.productCarouselMainImageWrapper > img,
.productCarouselMainImageWrapper > picture,
.productCarouselMainImageWrapper > picture img {
  width: var(--haus-imageCarousel__productCarousel__picture__width, 100%);
  height: var(--haus-imageCarousel__productCarousel__picture__height, 100%);
  aspect-ratio: var(--haus-imageCarousel__img__aspect-ratio, 1 / 1);
  object-fit: var(--haus-imageCarousel__img__object-fit, cover);
  object-position: var(--haus-imageCarousel__img__object-position, center);
  border-radius: var(--haus-imageCarousel__wrapper__border-radius, 6px);
}

.productCarouselThumbs {
  display: var(--haus-imageCarousel__productCarouselThumbs__display, flex);
  align-items: var(--haus-imageCarousel__productCarouselThumbs__align-items, center);
  justify-content: var(--haus-imageCarousel__productCarouselThumbs__justify-content, flex-start);
  flex-wrap: var(--haus-imageCarousel__productCarouselThumbs__flex-wrap, nowrap);
  gap: var(--haus-imageCarousel__productCarouselThumbs__gap, 1rem);
  padding: var(--haus-imageCarousel__productCarouselThumbs__padding, 8px);
  width: var(--haus-imageCarousel__productCarouselThumbs__width, max-content);
}

.productCarouselThumbs > * {
  gap: var(--haus-imageCarousel__productCarouselThumbs__item__gap, 8px);
}

.thumbnailNavigation {
  display: var(--haus-imageCarousel__thumbnailNavigation__display, flex);
  align-items: var(--haus-imageCarousel__thumbnailNavigation__align-items, center);
  justify-content: var(--haus-imageCarousel__thumbnailNavigation__justify-content, center);
  gap: var(--haus-imageCarousel__thumbnailNavigation__gap, 8px);
  width: var(--haus-imageCarousel__thumbnailNavigation__width, 100%);
}

.thumbViewport {
  width: var(--haus-imageCarousel__thumbViewport__width, auto);
  max-width: var(--haus-imageCarousel__thumbViewport__max-width, 100%);
  overflow-x: var(--haus-imageCarousel__thumbViewport__overflow-x, hidden);
  overflow-y: var(--haus-imageCarousel__thumbViewport__overflow-y, hidden);
}

.thumbViewportStepped {
  width: var(
    --haus-imageCarousel__thumbViewportStepped__width,
    calc(
      (
          var(--haus-imageCarousel__productCarouselThumbs__button__size, 60px) *
            var(--haus-imageCarousel__thumbViewport__max-visible-thumbnails, 5)
        ) + (
          var(--haus-imageCarousel__productCarouselThumbs__gap, 1rem) *
            (
              var(--haus-imageCarousel__thumbViewport__max-visible-thumbnails, 5) -
                1
            )
        )
    )
  );
  overflow-x: var(--haus-imageCarousel__thumbViewportStepped__overflow-x, hidden);
}

.thumbnailStepButton {
  display: var(--haus-imageCarousel__thumbnailStepButton__display, inline-flex);
  align-items: var(--haus-imageCarousel__thumbnailStepButton__align-items, center);
  justify-content: var(--haus-imageCarousel__thumbnailStepButton__justify-content, center);
  width: var(--haus-imageCarousel__thumbnailStepButton__width, 40px);
  height: var(--haus-imageCarousel__thumbnailStepButton__height, 40px);
  min-width: var(--haus-imageCarousel__thumbnailStepButton__min-width, 40px);
  min-height: var(--haus-imageCarousel__thumbnailStepButton__min-height, 40px);
  padding: var(--haus-imageCarousel__thumbnailStepButton__padding, 0);
  border: var(--haus-imageCarousel__thumbnailStepButton__border, none);
  border-radius: var(--haus-imageCarousel__thumbnailStepButton__border-radius, 50%);
  background-color: var(--haus-imageCarousel__thumbnailStepButton__background-color, transparent);
  color: var(--haus-imageCarousel__thumbnailStepButton__color, #333);
  cursor: var(--haus-imageCarousel__thumbnailStepButton__cursor, pointer);
  transition: var(
    --haus-imageCarousel__thumbnailStepButton__transition,
    background-color 0.2s ease,
    color 0.2s ease
  );

  &:hover:not(:disabled) {
    background-color: var(
      --haus-imageCarousel__thumbnailStepButton__hover__background-color,
      var(--haus-color-primary, #667eea)
    );
    color: var(--haus-imageCarousel__thumbnailStepButton__hover__color, #fff);
  }

  &:focus-visible {
    outline: var(--haus-imageCarousel__thumbnailStepButton__focus__outline, 2px solid currentColor);
    outline-offset: var(--haus-imageCarousel__thumbnailStepButton__focus__outline-offset, 2px);
  }

  &:disabled {
    opacity: var(--haus-imageCarousel__thumbnailStepButton__disabled__opacity, 0.4);
    cursor: var(--haus-imageCarousel__thumbnailStepButton__disabled__cursor, not-allowed);
  }
}

.productCarouselThumbs button {
  border: var(--haus-imageCarousel__productCarouselThumbs__button__border, 2px solid transparent);
  border-radius: var(--haus-imageCarousel__productCarouselThumbs__button__border-radius, 8px);
  background-color: var(
    --haus-imageCarousel__productCarouselThumbs__button__background-color,
    transparent
  );
  padding: var(--haus-imageCarousel__productCarouselThumbs__button__padding, 0);
  transition: var(--haus-imageCarousel__productCarouselThumbs__button__transition, all 0.3s ease);
  block-size: var(--haus-imageCarousel__productCarouselThumbs__button__size, 60px);
  inline-size: var(--haus-imageCarousel__productCarouselThumbs__button__size, 60px);
  overflow: hidden;
  display: block;
}

.productCarouselThumbButton[data-active='true'] {
  border-color: var(
    --haus-imageCarousel__productCarouselThumbs__button__active__border-color,
    var(--haus-color-primary, #667eea)
  );
  border-radius: var(
    --haus-imageCarousel__productCarouselThumbs__button__active__border-radius,
    8px
  );
  border-width: var(--haus-imageCarousel__productCarouselThumbs__button__active__border-width, 2px);
  box-shadow: var(
    --haus-imageCarousel__productCarouselThumbs__button__active__box-shadow,
    0 0 0 1px rgba(0, 0, 0, 0.25)
  );
}

.productCarouselThumbs .productCarouselThumbButton:hover:not(.disabled) {
  border-color: var(
    --haus-imageCarousel__productCarouselThumbs__button__hover__border-color,
    var(--haus-color-primary, #667eea)
  );
  border-radius: var(
    --haus-imageCarousel__productCarouselThumbs__button__hover__border-radius,
    8px
  );
  border-width: var(--haus-imageCarousel__productCarouselThumbs__button__hover__border-width, 2px);
  box-shadow: var(
    --haus-imageCarousel__productCarouselThumbs__button__hover__box-shadow,
    0 0 0 1px rgba(0, 0, 0, 0.25)
  );
}

// Thumb image border-radius matches button; use inner radius (radius minus border) so image aligns with visible edge
.productCarouselThumb {
  --haus-imageCarousel__productCarouselThumbs__thumb__outer-radius: var(
    --haus-imageCarousel__productCarouselThumbs__button__border-radius,
    var(--haus-imageCarousel__productCarouselThumbs__thumb__border-radius, 8px)
  );

  border-radius: var(
    --haus-imageCarousel__productCarouselThumbs__thumb__border-radius,
    calc(
      var(--haus-imageCarousel__productCarouselThumbs__thumb__outer-radius, 8px) - var(
          --haus-imageCarousel__productCarouselThumbs__button__border-width,
          2px
        )
    )
  );
  display: block;
  width: var(--haus-imageCarousel__productCarouselThumbs__thumb__width, 100%);
  height: var(--haus-imageCarousel__productCarouselThumbs__thumb__height, 100%);
  object-fit: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-fit, cover);
  object-position: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-position, center);
}

.productCarouselThumb img,
.productCarouselThumb picture {
  display: var(--haus-imageCarousel__productCarouselThumb__img__display, block);
  width: var(--haus-imageCarousel__productCarouselThumb__img__width, 100%);
  height: var(--haus-imageCarousel__productCarouselThumb__img__height, 100%);
  border-radius: inherit;
}

.productCarouselThumb img {
  object-fit: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-fit, cover);
  object-position: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-position, center);
}

.productCarouselThumb picture img {
  width: 100%;
  height: 100%;
  object-fit: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-fit, cover);
  object-position: var(--haus-imageCarousel__productCarouselThumbs__thumb__object-position, center);
}

.overlayBackdrop {
  position: fixed;
  inset: 0;
  z-index: var(--haus-imageCarousel__overlayBackdrop__z-index, 2147483646);
  background-color: var(
    --haus-imageCarousel__overlayBackdrop__background-color,
    rgba(0, 0, 0, 0.75)
  );
}

.overlayModal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--haus-imageCarousel__overlayModal__padding, 1.5rem);
  z-index: var(--haus-imageCarousel__overlayModal__z-index, 2147483647);
  background-color: var(--haus-imageCarousel__overlayModal__background-color, #fff);
  border-radius: var(--haus-imageCarousel__overlayModal__border-radius, 12px);

  @include bp.tablet {
    min-width: var(--haus-imageCarousel__overlayModal__tablet__min-width, min(640px, 90vw));
    max-width: var(--haus-imageCarousel__overlayModal__tablet__max-width, min(1024px, 90vw));
    width: var(--haus-imageCarousel__overlayModal__tablet__width, 90vw);
    max-height: var(--haus-imageCarousel__overlayModal__tablet__max-height, 82vh);
    padding: var(--haus-imageCarousel__overlayModal__tablet__padding, 1.25rem);
  }
}

.overlayCloseButton,
.overlayPrevButton,
.overlayNextButton {
  display: var(--haus-imageCarousel__overlayIconButton__display, flex);
  align-items: var(--haus-imageCarousel__overlayIconButton__align-items, center);
  justify-content: var(--haus-imageCarousel__overlayIconButton__justify-content, center);
  width: var(--haus-imageCarousel__overlayIconButton__width, 48px);
  height: var(--haus-imageCarousel__overlayIconButton__height, 48px);
  min-width: var(--haus-imageCarousel__overlayIconButton__min-width, 48px);
  min-height: var(--haus-imageCarousel__overlayIconButton__min-height, 48px);
  padding: var(--haus-imageCarousel__overlayIconButton__padding, 0);
  border: var(--haus-imageCarousel__overlayIconButton__border, none);
  border-radius: var(--haus-imageCarousel__overlayIconButton__border-radius, 50%);
  background-color: var(--haus-imageCarousel__overlayIconButton__background-color, transparent);
  color: var(--haus-imageCarousel__overlayIconButton__color, #333);
  cursor: var(--haus-imageCarousel__overlayIconButton__cursor, pointer);
  transition: var(
    --haus-imageCarousel__overlayIconButton__transition,
    background-color 0.2s ease,
    color 0.2s ease,
    border-radius 0.2s ease
  );

  &:hover:not(:disabled) {
    background-color: var(
      --haus-imageCarousel__overlayIconButton__hover__background-color,
      var(--haus-color-primary, #667eea)
    );
    color: var(--haus-imageCarousel__overlayIconButton__hover__color, #fff);
  }

  &:focus-visible {
    outline: var(--haus-imageCarousel__overlayIconButton__focus__outline, 2px solid currentColor);
    outline-offset: var(--haus-imageCarousel__overlayIconButton__focus__outline-offset, 2px);
  }

  &:disabled {
    opacity: var(--haus-imageCarousel__overlayIconButton__disabled__opacity, 0.4);
    cursor: var(--haus-imageCarousel__overlayIconButton__disabled__cursor, not-allowed);
  }
}

.overlayPrevButton,
.overlayNextButton {
  flex-shrink: var(--haus-imageCarousel__overlayPrevButton__flex-shrink, 0);
}

.overlayBody {
  display: flex;
  flex-direction: column;

  @include bp.tablet {
    margin-top: var(--haus-imageCarousel__overlayContent__tablet__margin-top, 2rem);
    gap: var(--haus-imageCarousel__overlayContent__tablet__gap, 0.75rem);
  }
}

.overlayHeader {
  display: flex;
  align-items: center;
  justify-content: var(--haus-imageCarousel__overlayHeader__justify-content, flex-end);
  gap: var(--haus-imageCarousel__overlayHeader__gap, 1.25rem);
  width: var(--haus-imageCarousel__overlayHeader__width, 100%);
}
